var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['theme/isRestaurantEnabled'])?_c('CartRestaurant'):_c('CartPickup')
}
var staticRenderFns = []

export { render, staticRenderFns }